import React from 'react'
import { Modal } from 'pcln-modal'
import { Box } from 'pcln-design-system'
import Form from '../SearchForm/Form'
import { onSubmitExpressDeal } from '../SearchForm/utils'
import StyledHeading from '../../StyledHeading'
import { FLIGHT_TYPE_INFO, ROUND_TRIP, ONE_WAY } from '../constants'
import useExpressDealModal from '../../CustomHooks/useExpressDealModal'
import { ANALYTICS_CATEGORY_FLIGHTS } from '../../../constants/analytics'

const PRIMARY_HEADING_TEXT = 'Search for Express Deal® Flights'
const SECONDARY_HEADING_TEXT = `Save up to 50% on trusted airlines!`

export default function ExpressDealModal({
  isModalOpen,
  gaCategory = ANALYTICS_CATEGORY_FLIGHTS,
  qsKey = 'modal',
  qsValue = 'express-deals'
}: {
  isModalOpen: boolean
  gaCategory?: string
  qsKey?: string
  qsValue?: string
}) {
  const { closeModal } = useExpressDealModal(qsKey, qsValue)
  return (
    <Modal
      isOpen={isModalOpen}
      onClose={closeModal}
      width={[1, 750]}
      enableOverflow
      timeout={50}
    >
      <Box p={[3, 0]}>
        <Box px={[0, 3]}>
          <StyledHeading
            aceContent={['SITE-X.HOMEPAGE.SEARCHAREA.EXPRESSDEALS.TITLE']}
            text={PRIMARY_HEADING_TEXT}
            fontSize={[3, null, null, 5]}
            lineHeight="1.25"
            tag="h1"
          />
          <StyledHeading
            text={SECONDARY_HEADING_TEXT}
            fontSize={[1, null, null, 4]}
            mb={3}
            lineHeight="1.25"
            tag="h2"
          />
        </Box>
        <Box pb={4} px={[0, 3]}>
          <Form
            onSubmit={values => onSubmitExpressDeal({ ...values, gaCategory })}
            promoDeal
            flightTypes={[
              FLIGHT_TYPE_INFO[ROUND_TRIP],
              FLIGHT_TYPE_INFO[ONE_WAY]
            ]}
          />
        </Box>
      </Box>
    </Modal>
  )
}
